module.exports = __webpack_public_path__ + "img/79.e64a535b.jpg";